













































import { Component, Prop, Vue } from 'vue-property-decorator'
import BuilderDeviceHighlight from '@/components/builder/BuilderDeviceHighlight.vue'
import { LocaleMessage } from 'vue-i18n'

@Component({
  components: {
    BuilderDeviceHighlight,
  },
})
export default class BuilderDeviceChatHeaderStub extends Vue {
  @Prop({ type: String }) icon!: string | null

  @Prop({ type: String }) siteName!: string
  
  @Prop({ required: true, type: String }) color!: string

  get formattedChatName(): string | LocaleMessage {
    return this.$t('chats')
  }
}
